import { useHotkeys } from 'react-hotkeys-hook';
import { shouldIgnoreVerifyMatchHotkey } from './useVerifyMatchDialogKeyboard';

export interface VerifyMatchMentionKeyboardHandlers {
  onAccept: () => void;
  onReject: () => void;
}

/**
 * A accepts (or un-accepts) the current mention; R rejects it after confirm.
 */
export function useVerifyMatchMentionKeyboard(
  enabled: boolean,
  handlers: VerifyMatchMentionKeyboardHandlers | null,
) {
  const onAccept = handlers?.onAccept;
  const onReject = handlers?.onReject;

  useHotkeys(
    'a',
    () => {
      onAccept?.();
    },
    {
      enabled: enabled && !!onAccept,
      enableOnFormTags: false,
      preventDefault: true,
      ignoreEventWhen: shouldIgnoreVerifyMatchHotkey,
    },
    [enabled, onAccept],
  );

  useHotkeys(
    'r',
    () => {
      onReject?.();
    },
    {
      enabled: enabled && !!onReject,
      enableOnFormTags: false,
      preventDefault: true,
      ignoreEventWhen: shouldIgnoreVerifyMatchHotkey,
    },
    [enabled, onReject],
  );
}
